import { isPlatformServer } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';

@Component({
  selector: 'global-bloomreach-banner-container',
  template: '',
  styleUrls: ['./banner-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class BloomreachBannerContainer implements OnInit, AfterViewInit, OnDestroy {
  private readonly _platformId = inject(PLATFORM_ID);

  @HostBinding('attr.data-bloomreach-container-id')
  @Input()
  id: string = '';

  @Output() contentAdded = new EventEmitter<MutationRecord>();
  @Output() contentCleared = new EventEmitter<MutationRecord>();

  private _observer?: MutationObserver;

  constructor(private _el: ElementRef) {
  }

  public ngOnInit(): void {
    if (!this.id) {
      throw new Error(`Property "id" for bloomreach container is required`);
    }
  }

  public ngAfterViewInit(): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }

    this._initMutationObserver();
  }

  public ngOnDestroy(): void {
    this._observer?.disconnect();
  }

  private _initMutationObserver(): void {
    this._observer = new MutationObserver((observer) => {
      const mutationRecord = observer[0];
      if (mutationRecord) {
        if (mutationRecord.addedNodes.length > 0) {
          this.contentAdded.next(mutationRecord);
        } else {
          if (mutationRecord.removedNodes.length > 0) {
            this.contentCleared.next(mutationRecord);
          }
        }
      }
    });

    this._observer.observe(this._el.nativeElement, {
      childList: true,
      subtree: true,
    });
  }
}
